import { safeHTML } from '../../../../utils/safeHTML';
import React from 'react';
import { useProgressData } from '../../../../hooks/shared/quests/useProgressData';
import { useLanguageControls } from '../../../../hooks/useLanguageControls';

export default function TaskItemTitle({ quest }) {
  const { text } = quest;
  const { necessaryProgress, necessaryTriggerCount, isVisibleProgress } = useProgressData({ quest });
  const { isArabic } = useLanguageControls();

  const progressLabel = isArabic
    ? `${necessaryTriggerCount}/${necessaryProgress}`
    : `${necessaryProgress}/${necessaryTriggerCount}`;

  return (
    <h3 className={'task__item-title'}>
      {safeHTML(text?.replace(/(\d) (\d)/g, '$1&nbsp;$2'))}

      {isVisibleProgress && (
        <span className={'task__item-title-counter'}>
          {safeHTML('&nbsp')}
          {progressLabel}
        </span>
      )}
    </h3>
  );
}
